import * as React from 'react';
import { Redirect, Route, RouteComponentProps, Switch } from 'react-router-dom';

import { AllSiteUsersSubspaceName } from '~src/app/state/SpaceInfo';

import { RouterError } from '../../RouterHelpers/RouterError';
import { SpacesSiteUrls } from '../../SpacesSiteUrls';
import { AllSiteUsersAndIdentitiesSpaceProvider } from './AllSiteUsersAndIdentitiesSpaceProvider';

export interface AllSiteUsersAndIdentitiesForSingleSiteSpaceRouterProps {
  readonly routeLocationPath: string;
  readonly routeLocationSearch: string;
  readonly urls: SpacesSiteUrls;
  readonly siteName: string;
}

export class AllSiteUsersAndIdentitiesForSingleSiteSpaceRouter extends React.Component<AllSiteUsersAndIdentitiesForSingleSiteSpaceRouterProps> {

  constructor(props: AllSiteUsersAndIdentitiesForSingleSiteSpaceRouterProps) {
    super(props);
  }

  public render() {
    return (
      <Switch>
        <Route exact path={this.props.urls.allUsersListPath()} render={this.provider('list')} />
        <Route exact path={this.props.urls.allUserIdentitiesPath()} render={this.provider('identities')} />

        <Route exact path={this.props.urls.usersPath()} render={() => (
          <Redirect to={this.props.urls.allUsersListPath()} />
        )} />

        <Route render={() => <RouterError errorType={'default'} urls={this.props.urls} />} />
      </Switch>
    );
  }

  private provider = (subspaceName: AllSiteUsersSubspaceName): (props: RouteComponentProps) => JSX.Element => {
    return (): JSX.Element => {
      return <AllSiteUsersAndIdentitiesSpaceProvider {...this.props}
        subspaceName={subspaceName}
      />;
    };
  }
}
